<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/Page-header";
import CheckModal from "@/components/CheckModal";
import DocumentActions from "@/components/document/DocumentActions.vue";
import authorityRequirementMatrixAPI from "@/services/standards/authorityRequirement/authorityRequirementMatrixAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import newScoresAPI from "@/services/newScores/newScoresAPI";
import Swal from "sweetalert2";

function blankRow() {
  return { fecha_requerimiento: null, entidad: null, requerimiento: "", accion_correctiva: "", responsable: "", estado: "Pendiente", evidencia_file: null, fecha_cierre: null, _uploading: false };
}

export default {
  page: { title: "Matriz de Seguimiento a Requerimientos" },
  components: { Layout, PageHeader, CheckModal, DocumentActions },
  data() {
    return {
      title: "7.1.4 Matriz de Seguimiento a Requerimientos de ARL y Autoridades",
      items: [
        { text: "Estándares", href: "/forms/estandares" },
        { text: "7.1.4 Requerimientos de autoridades y ARL", active: true },
      ],
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      matrixId: this.$route.params.matrix || null,
      catalog: { entidades: [], estados: [] },
      form: { version: "1.0", fecha: new Date().toISOString().substring(0, 10), observacion: null },
      rows: [blankRow()],
      workflowStatus: "draft",
      signedAt: null,
      submitting: false,
      loading: true,
    };
  },
  computed: {
    isSigned() { return this.workflowStatus === "signed"; },
    matrixApi() {
      return {
        pdfUrl: (id) => authorityRequirementMatrixAPI.pdfUrl(id),
        sign: (id, payload) => authorityRequirementMatrixAPI.sign(id, payload),
      };
    },
    dashboard() {
      let pend = 0, ejec = 0, cerr = 0;
      const n = this.rows.length;
      this.rows.forEach((r) => {
        if (r.estado === "Cerrada") cerr++;
        else if (r.estado === "En Ejecución") ejec++;
        else pend++;
      });
      return { total: n, pendientes: pend, en_ejecucion: ejec, cerradas: cerr, pct_cierre: n ? Math.round((cerr / n) * 100) : 0 };
    },
  },
  methods: {
    goBack() { this.$router.go(-1); },
    estadoCls(estado) {
      if (estado === "Cerrada") return "badge-success";
      if (estado === "En Ejecución") return "badge-warning";
      return "badge-danger";
    },
    addRow() { if (!this.isSigned) this.rows.push(blankRow()); },
    removeRow(idx) {
      if (this.isSigned) return;
      this.rows.splice(idx, 1);
      if (!this.rows.length) this.rows.push(blankRow());
    },
    fileName(url) { return String(url).split("/").pop(); },
    load() {
      if (!this.matrixId) { this.loading = false; return; }
      authorityRequirementMatrixAPI.get(this.matrixId)
        .then((r) => {
          if (!r) { this.loading = false; return; }
          this.form.version = r.version || "1.0";
          this.form.fecha = r.fecha ? String(r.fecha).substring(0, 10) : this.form.fecha;
          this.form.observacion = r.observacion || null;
          this.rows = (r.rows && r.rows.length)
            ? r.rows.map((x) => ({ ...blankRow(), ...x, fecha_requerimiento: x.fecha_requerimiento ? String(x.fecha_requerimiento).substring(0, 10) : null, fecha_cierre: x.fecha_cierre ? String(x.fecha_cierre).substring(0, 10) : null }))
            : [blankRow()];
          this.workflowStatus = r.workflow_status || "draft";
          this.signedAt = r.signed_at || null;
          this.loading = false;
        })
        .catch((e) => { console.log(e); this.loading = false; });
    },
    save() {
      if (this.isSigned) return;
      this.submitting = true;
      const payload = { companies_id: this.companyID, ...this.form, rows: this.rows };
      const req = this.matrixId ? authorityRequirementMatrixAPI.update(this.matrixId, payload) : authorityRequirementMatrixAPI.save(payload);
      req
        .then((res) => {
          newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 60, status: "Pendiente" }).catch(() => {});
          Swal.fire({ title: "¡Éxito!", text: "Matriz guardada.", icon: "success", timer: 1600, showConfirmButton: false });
          this.submitting = false;
          if (!this.matrixId && res && res.id) {
            this.matrixId = res.id;
            this.$router.replace({ path: `/forms/estandares/${this.companyID}/requerimiento-matriz/${res.id}` });
            this.load();
          }
        })
        .catch((e) => { console.log(e); this.submitting = false; Swal.fire("Error", "No se pudo guardar la matriz", "error"); });
    },
    async onEvidenceFile(row, event) {
      if (this.isSigned) return;
      const file = event.target.files[0];
      if (!file) return;
      row._uploading = true;
      try {
        const base = process.env.VUE_APP_ENV === "development" ? "sst-dev" : "sst-prod";
        const path = `${base}/${this.nit}/7.1.4/matriz-evidencias/${this.matrixId || "nuevo"}/${Date.now()}_${file.name}`;
        const ok = await uploadDocument(path, file);
        if (!ok) throw new Error("upload");
        row.evidencia_file = `${process.env.VUE_APP_BUCKET}/${path}`;
        Swal.fire({ title: "Evidencia cargada", icon: "success", timer: 1200, showConfirmButton: false });
      } catch (e) {
        console.log(e);
        Swal.fire("Error", "No se pudo cargar la evidencia", "error");
      } finally {
        row._uploading = false;
        if (event.target) event.target.value = null;
      }
    },
    removeEvidence(row) { if (!this.isSigned) row.evidencia_file = null; },
    onSigned(payload) {
      this.workflowStatus = payload.workflow_status;
      this.signedAt = payload.signed_at;
    },
  },
  mounted() {
    authorityRequirementMatrixAPI.catalog().then((c) => { if (c) this.catalog = { ...this.catalog, ...c }; });
    this.load();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-9" v-if="!loading">
        <div class="card">
          <div class="card-body">
            <CheckModal>
              <p class="text-justify">
                Tablero de seguimiento a los requerimientos emitidos por autoridades competentes y la ARL. Por cada
                requerimiento indica la fecha, la entidad emisora, la recomendación/requerimiento, la acción correctiva,
                el responsable, el estado y la fecha de cierre. Cada guardado es una versión y puede firmarse; usa "Nueva
                versión" en el listado para conservar el historial en el tiempo.
              </p>
            </CheckModal>

            <div v-if="isSigned" class="alert alert-success py-2 my-2 small">
              🔒 Esta versión ya fue firmada; los datos quedan bloqueados. Crea una "Nueva versión" desde el listado.
            </div>

            <form @submit.prevent="save">
              <div class="form-row">
                <b-form-group class="col-md-2 px-2" label="Versión"><b-form-input type="text" v-model="form.version" :disabled="isSigned" /></b-form-group>
                <b-form-group class="col-md-3 px-2" label="Fecha"><b-form-input type="date" v-model="form.fecha" :disabled="isSigned" required /></b-form-group>
                <b-form-group class="col-md-7 px-2" label="Observación"><b-form-input type="text" v-model="form.observacion" :disabled="isSigned" /></b-form-group>
              </div>

              <div class="d-flex justify-content-between align-items-center mt-2">
                <h5 class="mb-0">Requerimientos</h5>
                <span class="small">
                  <span class="badge badge-danger">Pendientes: {{ dashboard.pendientes }}</span>
                  <span class="badge badge-warning">En ejecución: {{ dashboard.en_ejecucion }}</span>
                  <span class="badge badge-success">Cerradas: {{ dashboard.cerradas }}</span>
                  <span class="badge badge-info">% Cumplimiento: {{ dashboard.pct_cierre }}%</span>
                </span>
              </div>

              <div v-for="(row, idx) in rows" :key="idx" class="border rounded p-2 mb-3">
                <div class="d-flex justify-content-between">
                  <strong class="small text-primary">Requerimiento #{{ idx + 1 }}</strong>
                  <button type="button" class="btn btn-outline-danger btn-sm py-0" :disabled="isSigned" @click="removeRow(idx)"><i class="mdi mdi-trash-can"></i></button>
                </div>
                <div class="form-row">
                  <b-form-group class="col-md-2 px-2" label="Fecha requerimiento"><b-form-input type="date" v-model="row.fecha_requerimiento" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Entidad emisora">
                    <b-form-select v-model="row.entidad" :disabled="isSigned" size="sm">
                      <b-form-select-option :value="null">Seleccione...</b-form-select-option>
                      <b-form-select-option v-for="e in catalog.entidades" :key="e" :value="e">{{ e }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group class="col-md-4 px-2" label="Recomendación / requerimiento"><b-form-input v-model="row.requerimiento" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Estado">
                    <b-form-select v-model="row.estado" :disabled="isSigned" size="sm">
                      <b-form-select-option v-for="s in catalog.estados" :key="s" :value="s">{{ s }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
                <div class="form-row align-items-end bg-light rounded py-1">
                  <b-form-group class="col-md-5 px-2" label="Acción correctiva (plan de acción)"><b-form-input v-model="row.accion_correctiva" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Responsable"><b-form-input v-model="row.responsable" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-2 px-2" label="Fecha cierre"><b-form-input type="date" v-model="row.fecha_cierre" :disabled="isSigned" size="sm" /></b-form-group>
                  <div class="col-md-2 px-2 pb-2"><span class="badge" :class="estadoCls(row.estado)">{{ row.estado }}</span></div>
                </div>
                <div class="form-row align-items-end">
                  <b-form-group class="col-md-6 px-2" label="Soporte / evidencia">
                    <b-form-file :disabled="isSigned || row._uploading" browse-text="Buscar" :placeholder="row._uploading ? 'Subiendo...' : 'Selecciona un archivo...'" @change="onEvidenceFile(row, $event)" size="sm" />
                  </b-form-group>
                  <div class="col-md-6 px-2 pb-2 small">
                    <span v-if="row.evidencia_file">
                      <a :href="row.evidencia_file" target="_blank"><i class="mdi mdi-paperclip"></i> {{ fileName(row.evidencia_file) }}</a>
                      <button v-if="!isSigned" type="button" class="btn btn-outline-danger btn-sm py-0 ml-1" @click="removeEvidence(row)"><i class="mdi mdi-close"></i></button>
                    </span>
                    <span v-else class="text-muted">Sin archivo</span>
                  </div>
                </div>
              </div>

              <button type="button" class="btn btn-outline-primary btn-sm mb-3" :disabled="isSigned" @click="addRow"><i class="mdi mdi-plus"></i> Agregar requerimiento</button>

              <div class="text-right">
                <button type="submit" :disabled="isSigned || submitting" class="btn btn-primary mx-1">Guardar</button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-lg-3" v-if="!loading && matrixId">
        <h6 class="text-muted small mb-1">Matriz de Seguimiento a Requerimientos</h6>
        <DocumentActions
          :document-id="Number(matrixId)"
          :company-id="companyID"
          :workflow-status="workflowStatus"
          :signed-at="signedAt"
          :api-service="matrixApi"
          document-title="Matriz de Seguimiento a Requerimientos de ARL y Autoridades"
          signer-role="gerente"
          @signed="onSigned"
        />
      </div>

      <div v-if="loading" class="col-12 text-center"><b-spinner variant="primary" label="Loading..."></b-spinner></div>
    </div>
  </Layout>
</template>
